import { reactive } from "@vue/composition-api";
import { apiEndpoint } from "@/configs/api/api-configs";

export default function luckyWinnerRoundModel() {
  const createRound = reactive({
    api: apiEndpoint.bcrm_platform + "/LuckyWinner/CreateRound",
    method: "POST",
    xRequest: "",
    payload: {
        CampaignId: "",
        Description: "",
        Startdate: "",
        Starttime: "",
        Enddate: "",
        Endtime: "",
        Status: false
    },
  });

  const editRound = reactive({
    api: apiEndpoint.bcrm_platform + "/LuckyWinner/EditRound",
    method: "POST",
    xRequest: "",
    payload: {
        Id: "",
        CampaignId: "",
        Description: "",
        Startdate: "",
        Starttime: "",
        Enddate: "",
        Endtime: "",
        Status: false
    },
  });

  const fetchRoundDetail = reactive({
    api: apiEndpoint.bcrm_platform + "/LuckyWinner/RoundDetail",
    method: "GET",
    xRequest: "",
    payload: {
        RoundId: null
    },
  });

  const fetchRoundList = reactive({
    api: apiEndpoint.bcrm_platform + "/LuckyWinner/RoundList",
    method: "GET",
    xRequest: "",
    payload: {
      Page: 1,
      Limit: 10,
      Filters: [],
      CampaignId: null
    },
  });

  const setRoundStatus = reactive({
    api: apiEndpoint.bcrm_platform + "/LuckyWinner/SetRoundStatus",
    method: "POST",
    xRequest: "",
    payload: {
        Id: "",
        CampaignId: "",
        Status: true
    },
  });

  return {
    createRound,
    editRound,
    fetchRoundDetail,
    fetchRoundList,
    setRoundStatus
  };
}